<header class="agenx-header">
  <div class="agenx-header__logo">
    <img class="agenx-header__img" src="/assets/img/Logo_Aforos_genXapp.png" alt="logo">
  </div>
  <div>
    <agenx-button [buttonText]="'Cerrar sesión'" [typeButton]="'lightblue'" (click)="logout()"></agenx-button>
  </div>
</header>
